<template>
<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M4.35714 6L5.71429 22H19.2857L20.6429 6M4.35714 6H20.6429M4.35714 6H3V4H9.78571M20.6429 6H22V4H15.2143M9.78571 4V2H15.2143V4M9.78571 4H15.2143M9.78571 10.6667V16M12.5 10.6667V16M15.2143 10.6667V16" stroke="#458EAF"/>
</svg>
</template>
